import View0001 from '../images/view0001.png'
import View0002 from '../images/view0002.jpg'
import View0003 from '../images/view0003.jpg'
import View0004 from '../images/view0004.png'
import View0005 from '../images/view0005.jpg'
import View0006 from '../images/view0006.png'

// 投稿情報を保存する配列
// {'authorid': {'postid': {title: string, cover: img, tag: string, body: string. createdAt: string}}}
export const postdata: {
  [key: string]: { [key: string]: { [key: string]: string } }
} = {
  tomoyanagishita63: {
    '0': {
      title: 'ネジザウルス',
      cover: 'https://m.media-amazon.com/images/I/71AQG7AM4LL._AC_SX569_.jpg',
      tag: '',
      body: '一家に一つあるとかなり便利。僕はベットの解体組み立てなどに使いました。ネジ穴が潰れてしまっていたが、これのおかげで簡単にネジを取り外すことが出来た。何かと使える。',
      href: 'https://amzn.to/3FhHNFF',
      createdAt: '2022/01/12',
    },
    '1': {
      title: 'ドアの防音クッション',
      cover: 'https://m.media-amazon.com/images/I/416wthf31GL._AC_SY1000_.jpg',
      tag: '',
      body: '隙間風、防音対策に。様々なサイズがあり(厚さ、幅)どんなドアにも対応。閉めるとき多少きつくなる部分はあるが、かなりの防音対策になる。在宅の際など、家族の生活音も気にならなくなる。',
      href: 'https://amzn.to/3zNqRpE',
      createdAt: '2022/01/12',
    },
    '2': {
      title: 'アイリスオーヤマ　扇風機　サーキュレーターアイ',
      cover: 'https://m.media-amazon.com/images/I/41mYkqL8RWS._AC_SY580_.jpg',
      tag: '',
      body: 'コンパクトで風が強い。持ち運びにも便利で、様々な部屋に持ち出し可能。湿気の強い時期部屋干しなどが乾きやすい。クーラー使用時、冷房の場合は上下左右に首を振ると部屋中が涼しくなりやすく、暖房時は上に暖かい空気が溜まりがちなので上向きにして左右に首を振ると部屋全体が暖かくなる。',
      href: 'https://amzn.to/3fcgSRg',
      createdAt: '2022/01/12',
    },
    '3': {
      title: 'トリエ　ヘアスプレー',
      cover: 'https://m.media-amazon.com/images/I/21sobHrzhDL._AC_SY580_.jpg',
      tag: '',
      body: 'もう10年以上これしか使っていません。様々なスプレーを試してきました。僕はとても猫毛なので、ワックスとスプレーをするとその重さで、すぐにぺったんこになってしまいますが、これだけは違います。舞台に出ていた時も常にこれでした。かなりのキープ力、それも自分で調整できる。ガチガチにはならない。\nhttps://www.lebel.co.jp/products/styling/trie/lineup.html',
      href: 'https://amzn.to/3fwnYjP',
      createdAt: '2022/01/12',
    },
    '4': {
      title: '京都　北野　長文屋　七味',
      cover:
        'https://ximg.retty.me/crop/s200x200/-/retty/img_repo/l/01/27363919.jpg',
      tag: '',
      body: '山椒が良い感じで聞いている七味です。山椒を抑えたものもありますますが、断然山椒入りをお勧めします。様々な料理が引き立つ。特におすすめはぶっかけそばに大量にこの七味をかけると食欲が止まりません。山椒好きは必ず試してほしい。',
      href: 'https://retty.me/area/PRE26/ARE115/SUB47602/100000786812/?utm_y_pc_res_title',
      createdAt: '2022/01/12',
    },
    '5': {
      title: 'アイリスオーヤマ　スマートリモコン',
      cover: 'https://m.media-amazon.com/images/I/51lNVqpEsFS._AC_SX569_.jpg',
      tag: '',
      body: '本当に便利。家の家電がどこからでもON,OFF出来ます。もちろん外出中でも電源を入れれます。防犯対策にもなりますし、ペットがいる家庭では、部屋の温度管理等も可能。僕は寝転がったままスマートフォン一つで電気、テレビ、エアコンの操作をしてます（笑）',
      href: 'https://amzn.to/3qjJ7nk',
      createdAt: '2022/01/12',
    },
    '6': {
      title: '[アイシャツ] i-shirt 完全ノーアイロン ストレッチ...',
      cover: 'https://m.media-amazon.com/images/I/71cVE2EQjtL._AC_UY1000_.jpg',
      tag: '',
      body: '社会人になり、一番重宝している服です。洗濯後とにかくアイロンが要らない。着心地もサラサラで肌触りが良い。夏は同じシリーズの半袖にしています。３～4枚をローテーションしております。',
      href: 'https://amzn.to/33nKZ5t',
      createdAt: '2022/01/12',
    },
    '7': {
      title: 'ヒポポタマス　タオル',
      cover: 'https://m.media-amazon.com/images/I/51QcRtgw12L._AC_SY580_.jpg',
      tag: '',
      body: 'ここのタオルは別格。良いタオルは世の中にたくさんあります。僕もいろいろなところのタオルを頂いたりなどで使わせて頂きました。個人差はもちろんあるとは思いますが、僕は断然個々のタオル一択です。出会ってから全部を入れ替えたくて少しずつ買い替えている所です。大切な方へのプレゼントとしても喜ばれると思います。',
      href: 'https://amzn.to/3zNrlMu',
      createdAt: '2022/01/12',
    },
    '8': {
      title: 'BEAMS HEART / チェック ダウン ジャケット',
      cover:
        'https://cdn.beams.co.jp/img/goods/42180516413/L/42180516413_D_5.jpg',
      tag: '',
      body: 'とにかく暖かい。着た時のシルエットも良し。帽子を取り外し出来るので、カジュアルはもちろん、軽いフォーマル、ビジネスでも使用可能だと思います。細いパンツと併せればスタイル良く見えるし、価格もリーズナブル。久々に一目ぼれの即決しました。',
      href: 'https://www.beams.co.jp/item/beamsheart/blouson/42180516413/?color=15',
      createdAt: '2022/01/12',
    },
  },
  tano: {
    '0': {
      title: 'ミスターチーズケーキ',
      cover: View0002,
      tag: '#グルメ #ミスチ #Mr.CHEESECAKE',
      body: '世界一じゃなく、あなたの人生最高に。 濃厚なのにスッと溶ける。 おいしい記憶をたどり、シェフだからこその味わいを生み出す。 世界へ誇るトーキョーチーズケーキを。EC限定で毎週日曜・月曜のみ販売。誕生日・記念日の贈答品、プレゼントにもオススメです。',
      href: 'https://mr-cheesecake.com/',
      createdAt: '2021/12/05',
    },
    '1': {
      title: 'スタートアップ夢の扉',
      cover: View0006,
      tag: '#映画 #Netflix #おもしろ',
      body: '面白かった映画<br/>なんか挑戦したいと思えるし、クスッと笑える瞬間が所々にあって面白いです。',
      href: 'https://www.netflix.com/jp/title/81290293',
      createdAt: '2021/11/25',
    },
  },
  prof: {
    '0': {
      title: 'X-E4　スナップが捗る最強のカメラ',
      cover: View0001,
      tag: '#カメラ #X-E4',
      body: 'X-E4のデザインは、X-E4に込めた想いを体現している。\
        <br />極限まで薄さにこだわったソリッドなレンジファインダースタイルは、カメラを日常的に持ち歩くスタイルや自由な撮影を助けてくれる。\
        <br />フィルムカメラを彷彿させる軍艦部のダイヤル類は、メカニカルな操作を行うことの楽しさを喚起するだけでなく、電源オフ時であっても露出設定を研ぎ澄ます大切さを教えてくれる。気楽に、身軽に、しかし本格的に。X-E4で撮影の本質に触れる。',
      href: 'https://online.nojima.co.jp/commodity/1/4547410442625/',
      createdAt: '2021/12/05',
    },
  },
}
